var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60611 8.41424C9.2622 6.81833 12.0144 6.81833 13.6705 8.41424C15.1598 9.84967 15.3802 12.1378 14.156 13.7885L14.1232 13.8344C13.8164 14.245 13.2207 14.3426 12.7948 14.0469C12.3659 13.7512 12.2646 13.177 12.5714 12.7665L12.6042 12.7205C13.2862 11.799 13.179 10.5387 12.348 9.73771C11.4127 8.83626 9.89068 8.83626 8.95243 9.73771L5.61047 12.9617C4.67192 13.8402 4.67192 15.3302 5.61047 16.2345C6.43851 17.0354 7.74909 17.1388 8.70223 16.4814L8.74988 16.424C9.1788 16.1541 9.77451 16.2488 10.0783 16.6622C10.3851 17.0756 10.2868 17.6498 9.85791 17.9455L9.81026 17.9771C8.07077 19.157 5.75046 18.9675 4.26148 17.535C2.57951 15.9129 2.57951 13.2832 4.26148 11.6641L7.60611 8.41424ZM16.3929 15.5598C14.71 17.1819 11.9846 17.1819 10.3017 15.5598C8.81243 14.1244 8.61883 11.8621 9.84302 10.2114L9.87578 10.1655C10.1558 9.75493 10.7515 9.65732 11.2042 9.95302C11.6331 10.2229 11.7344 10.7971 11.4276 11.2334L11.3949 11.2794C10.7128 12.1751 10.82 13.4612 11.651 14.2622C12.5863 15.1636 14.1083 15.1636 15.0466 14.2622L18.3885 11.0382C19.3268 10.1339 19.3268 8.64391 18.3885 7.76543C17.5605 6.96532 16.2499 6.86082 15.2968 7.51853L15.2491 7.55011C14.8202 7.84581 14.2245 7.72523 13.9207 7.33709C13.6139 6.92426 13.7122 6.35038 14.1411 6.05554L14.1888 6.02339C15.9014 4.84378 18.2485 5.03093 19.7378 6.46607C21.4207 8.08696 21.4207 10.7167 19.7378 12.3358L16.3929 15.5598Z",
    fill: "#031D60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.f4781fe34cadae9a2a96d906e803e099.svg";
export { ForwardRef as ReactComponent };